import { CalendarDoorElement } from "./types";
import { ShareToSocialMedia } from "../SocialMedia/ShareToSocialMedia";
import { useCommonData } from "../../layout/CommonDataProvider";
import { getSiteUrl } from "@libry-content/common";

import { VideoEmbed } from "../../VideoEmbed";

export const Video: CalendarDoorElement<"adventCalendarDoorVideo"> = ({ door, date }) => {
  const { site } = useCommonData();
  const shareUrl = site ? `${getSiteUrl(site)}/kampanje/julekalender` : undefined;

  return (
    <>
      <VideoEmbed value={door.video} width="100%" maxWidth="100%" margin="0" />
      {shareUrl && (
        <ShareToSocialMedia shareUrl={shareUrl} type="adventCalendarDoorVideo" date={date} marginTop="1rem" />
      )}
    </>
  );
};
